import BeneficiaryForm from '../components/BeneficiaryForm';
import { add_provider } from '../api/provider_api';
import { useNavigate } from 'react-router-dom';
import { isValidIsraeliID } from '../utils/validationId';

const AddProvider = () => {
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const provider = {
            id: e.target.id.value,
            full_name: e.target.full_name.value,
            address: e.target.address.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            comments: e.target.comments.value,
            contact_person: e.target.contact_person.value,
            contact_phone: e.target.contact_phone.value
        };
        console.log("provider", provider);
        
        // if (!isValidIsraeliID(beneficiary.id)) {
        //     alert("מספר ת.ז. לא תקין");
        //     return;
        // }
        try {
            await add_provider(provider);
            alert('הספק נוסף בהצלחה!');
            navigate('/beneficiaries');
        } catch (err) {
            if (err.status === 409) {
                alert('ח.פ. כבר קיים במערכת');
            } else {
                alert('הוספת הספק נכשלה');
            }
        }
    };

    return (
        <>
            <div className="top-buttons-container">
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <h2 style={{ color: "#150F6B", textAlign: "center" }}>הוספת ספק</h2>
            </div>
            <BeneficiaryForm mode="add" kind={"provider"} onSubmit={handleSubmit} />
        </>
    );
};

export default AddProvider;
